import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import constants from 'src/constants';
import HvSvg from 'src/components/HvSvg';
import uiDux from 'src/redux/ui';
import {
  DesignPickerContainer,
  OriginalDesignButton,
  SavedDesignContainer,
  SavedDesignButton,
  LockIconContainer,
} from './styled';

const { MODE_NAMES } = constants.app;

export const mapStateToProps = ({ designPro }) => ({
  isSidebarOpen: designPro.ui.isSidebarOpen,
  jobDesigns: designPro.jobDesigns.jobDesigns,
  selectedDesignId: designPro.jobDesigns.selectedDesignId,
  isInScreenshotMode: designPro.app.activeMode === MODE_NAMES.SCREENSHOT,
});

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleSelectDesignClick: uiDux.actions.handleSelectDesignClick,
    },
    dispatch,
  );

export class DesignPicker extends PureComponent {
  // eslint-disable-next-line
  static propTypes = {
    selectedDesignId: PropTypes.number.isRequired,
    isSidebarOpen: PropTypes.bool.isRequired,
    isInScreenshotMode: PropTypes.bool.isRequired,
    handleSelectDesignClick: PropTypes.func.isRequired,
    jobDesigns: PropTypes.shape({
      original: PropTypes.object.isRequired,
      saved: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
  };

  render() {
    const {
      handleSelectDesignClick,
      isInScreenshotMode,
      isSidebarOpen,
      jobDesigns,
      selectedDesignId,
    } = this.props;
    const { saved = [], original = {} } = jobDesigns;
    const isOriginalSelected = original.id === selectedDesignId;

    if (isSidebarOpen || !saved.length || isInScreenshotMode) return null;

    return (
      <DesignPickerContainer>
        <OriginalDesignButton
          onClick={() => handleSelectDesignClick(original.id)}
          isSelected={isOriginalSelected}
          data-selenium="originalDesignButton"
        >
          <LockIconContainer size={12}>
            <HvSvg
              src={require('src/assets/icons/ic-lock.svg')}
              disabled={false}
            />
          </LockIconContainer>
          Original
        </OriginalDesignButton>
        <SavedDesignContainer
          data-selenium="savedDesignButton"
          isSelected={!isOriginalSelected}
        >
          <SavedDesignButton
            onClick={() => handleSelectDesignClick(saved[0].id)}
          >
            Saved Design
          </SavedDesignButton>
        </SavedDesignContainer>
      </DesignPickerContainer>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DesignPicker);
